import { useState } from "react";

export const PlayerAvatar = ({ src, name, size = 40, className = "" }) => {
  const [err, setErr] = useState(false);
  const parts = (name || "?").trim().split(" ");
  const initial = (parts[parts.length - 1][0] || "?").toUpperCase();
  const dim = { width: size, height: size };
  if (src && !err) {
    return (
      <img
        src={src} alt={name} onError={() => setErr(true)} loading="lazy"
        style={dim}
        className={`shrink-0 rounded-full bg-slate-100 object-cover object-top ${className}`}
      />
    );
  }
  return (
    <span
      style={{ ...dim, fontSize: size * 0.42 }}
      className={`flex shrink-0 items-center justify-center rounded-full bg-volt font-display font-black text-ink ${className}`}
    >
      {initial}
    </span>
  );
};
